import PropTypes from 'prop-types';
import React from 'react';


function FormError ({ id, className, message }) {
    return (
        <p id={id} className={ 'alert alert-danger ' + className }>
            { message }
        </p>
    );
}


FormError.propTypes = {
    id: PropTypes.string,
    message: PropTypes.string.isRequired,
    className: PropTypes.string
};

FormError.defaultProps = {
    className: ''
};


export default FormError;



// WEBPACK FOOTER //
// ./src/components/form/Error.js